import React, { Suspense, lazy } from 'react';
import { ExternalLink, LoadingIndicator, Logo } from '@monash/portal-react';
import c from './access-denied.module.scss';
import { SpilledFlowers } from './SpilledFlowers';
import { EXTERNAL_LINKS } from '../constants/external-links';

const EncumbranceDucks = lazy(
  () => import('../components/encumbrance-notification/EncumbranceDucks'),
);

const AccessDenied = ({ blocked }) => {
  const content = blocked ? (
    <div className={c.encumbrance}>
      <div className={c.svgWrapper}>
        <Suspense fallback={<LoadingIndicator color="white" />}>
          <EncumbranceDucks />
        </Suspense>
      </div>
      <h1 className={c.title}>You have an encumbrance.</h1>
      <div>
        <p className={c.description}>
          It looks like there’s a block on your account (an encumbrance), so you
          won’t be able to access the apps right now.
        </p>
        <p className={c.description}>
          Check your Monash email for all the details (including how to remove
          the block). If you’re enrolled at an Australian campus, you can use
          our encumbrance check in the virtual assistant to find out what you
          need to do.
        </p>
      </div>
      <ExternalLink
        text="Encumbrance check"
        link={EXTERNAL_LINKS.ENCUMBRANCE}
        type="primary"
      />
    </div>
  ) : (
    <div>
      <div className={c.svgWrapper}>
        <SpilledFlowers />
      </div>
      <h1 className={c.title}>Access Denied</h1>
      <p className={c.description}>
        Sorry, you don’t have permission to access this application.
      </p>
    </div>
  );

  return (
    <>
      <div className={c.logo}>
        <Logo.MonashStacked height={25} />
      </div>

      <div className={c.wrapper}>{content}</div>
    </>
  );
};

export default AccessDenied;
